export default "__VITE_ASSET__B5CInV9q__"